<template>
  <div class="flex flex-col max-w-6xl px-6 py-16 md:py-0.5 mx-auto md:flex-row">
    <div class="flex flex-col justify-center pr-4 md:w-1/2">
      <div>
        <a class="inline-flex items-center pl-1 pr-2 mb-3 bg-red-100 rounded-full dark:bg-gray-700" href="#">
          <span class="px-2 py-px mr-2 text-xs font-bold text-red-100 uppercase bg-red-700 rounded-full">New</span>
          <span class="text-sm leading-loose text-red-800 dark:text-gray-300">Creat your shorten website with our API →</span>
        </a>
      </div>
      <h1 class="text-5xl font-extrabold leading-none tracking-tight text-gray-800 lg:text-6xl dark:text-gray-300">Short URL with QR code free today !</h1>
      <p class="mt-6 mb-12 text-lg text-gray-700 dark:text-gray-400">Modern link shortening platform, applying QR code technology to make everything perfect.</p>
      <div>
        <div class="flex items-center">
          <div class="relative border-dashed border-4 border-light-blue-500">
            <div class="absolute top-5 left-3">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-gray-400 z-20" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clip-rule="evenodd" />
              </svg>
            </div>
            <input type="text" class="h-14 md:w-128 pl-10 pr-20 z-0 shadow focus:outline-none" placeholder="https://" />
            <div class="absolute top-2 right-2 transform hover:translate-x-8 duration-300"><button class="h-10 w-20 text-white rounded-lg bg-red-500 hover:bg-red-600">Shrink →</button></div>
          </div>
        </div>
      </div>
    </div>
    <div class="md:w-1/2">
      <img class="w-full" :src="require(`@/assets/images/home/media-bro.svg`)" alt="Connect ShortLink with people!" />
    </div>
  </div>
</template>